import Config from '@/modules/config/classes/Config';
import type { KnownConfig } from '@/modules/config/types/known-config';
import { container } from 'tsyringe';
import type { Get, Paths } from 'type-fest';

export default function config<K extends Paths<KnownConfig>>(
  key: K
): Get<KnownConfig, K>;
export default function config<K extends Paths<KnownConfig>>(
  key: K,
  defaultValue: Get<KnownConfig, K>
): Exclude<Get<KnownConfig, K>, undefined>;
export default function config<K extends Paths<KnownConfig>>(
  key: K,
  defaultValue: unknown
): Exclude<Get<KnownConfig, K>, undefined>;
export default function config<T = unknown>(key: string, defaultValue?: T): T;
/**
 * Get a configuration value
 * @param key - The key of the configuration value
 * @param defaultValue - The default value if the configuration value is not found
 * @returns The configuration value or the default value if the configuration value is not found
 */
export default function config(key: string, defaultValue?: unknown): unknown {
  const config = container.resolve(Config);
  const value = config.get(key, defaultValue);
  return value;
}
